import { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { MDSTheme, MDSTypography } from '@marqvision/mds/core';
import { useAuth } from '~/apis/auth';
import { GlobalActionContext } from '~/App';
import { useLanguage } from '~/hooks';
import { useBreakpoint } from '~/hooks';

export const ProtectedRoute = () => {
  const { data: authData } = useAuth();
  const { login } = useContext(GlobalActionContext);
  const { Lang } = useLanguage();
  const { getMediaQueryValue: mq } = useBreakpoint();

  if (!authData?.accessToken) {
    login(undefined, true);

    const url = window.location.href;

    let pageName = Lang.ThisPage;
    if (url.indexOf('/payment') >= 0) {
      pageName = Lang.Payment;
    } else if (url.indexOf('documents') >= 0) {
      pageName = Lang.Documents;
    }

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '20px',
          height: '100%',
          padding: mq('40px 0', '40px 0', 0),
        }}
      >
        <MDSTypography variant="T20" weight="medium" color={MDSTheme.palette.bluegray[850]}>
          {Lang.PleaseSignIn}
        </MDSTypography>
        <MDSTypography variant="T14" color={MDSTheme.palette.bluegray[700]}>
          {Lang.ToContinueTo(pageName.toLowerCase())}
        </MDSTypography>
      </div>
    );
  }

  return <Outlet />;
};
